import { _, React, withStyles, StyledProps, classNames } from '@api'
import { NoteAdd } from '@material-ui/icons'
import { SecondaryButton, NoteDefinition, CentricTheme } from 'centric-ui-components'

const styles = (theme: CentricTheme) => ({
  root:     {
    height: 64,
    width:  '100%'
  },
  noteIcon: {
    width:     20,
    height:    20,
    marginTop: 2
  },
  footer:   {
    height:         64,
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'flex-end'
  },
  button: {
    position: 'absolute',
    height: 48,
    width: 48,
    left: `-${theme.spacing() * 10}px`,
    bottom: theme.spacing() * 4
  }
})

interface MyProps extends StyledProps {
  notes: Array<NoteDefinition>
  loading?: boolean
  isDirty?: boolean
  onClickSaveProduct?: (e) => void
  onClickCancelProduct?: (e) => void,
  onClickNotes?: (e) => void
}

export class ProductFooterComponent extends React.Component<MyProps> {
  static defaultProps = {
    notes:   [],
    isDirty: false
  }

  render() {
    const {notes, loading, classes, onClickNotes} = this.props
    return (
      <div className={classNames(classes.footer)} data-loading={loading}>
        <SecondaryButton
          onClick={onClickNotes}
          loading={loading}
          icon={{position: 'left', component: <NoteAdd className={classes.noteIcon}/>}}
          classes={{root: classes.root}}>
          {notes.length === 0 ? 'Add Note'
          : `Notes (${notes.length})`}
          </SecondaryButton>
        {/* {isDirty === true &&
        <div>
          <TertiaryButton key={'product-footer-Cancel'} onClick={onClickCancelProduct}>Cancel</TertiaryButton>
          <SecondaryButton key={'product-footer-save'} onClick={onClickSaveProduct}>Save</SecondaryButton>
        </div>} */}
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class ProductFooter extends ProductFooterComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/ProductFooter.tsx